var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdminFailureCodes',{attrs:{"pk":'SFC-',"lockedFilters":{ SupplierIdList: [_vm.$route.params.supplierId] },"hideFilters":""}})}
var staticRenderFns = []

export { render, staticRenderFns }